/*
 * @Author: 罗川平 2150673512@qq.com
 * @Date: 2022-07-16 10:27:28
 * @LastEditors: 罗川平 2150673512@qq.com
 * @LastEditTime: 2022-07-17 18:13:07
 * @FilePath: \manger\src\router\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login'
import Manger from '../views/Manger'
import index from '../views/index'
import NewOrder from '../views/NewOrder'
import NewArea from '../views/NewArea'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Login',
    component: Login
  },
  {
    path: '/manger',
    name: 'Manger',
    component: Manger,
    redirect: '/index',
    children: [
      {
        path: '/index',
        name: 'index',
        component: index
      },
      {
        path: '/neworder',
        name: 'NewOrder',
        component: NewOrder
      },
      {
        path: '/newarea',
        name: 'NewArea',
        component: NewArea
      },
    ]
  },
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
